import React from 'react'
import PropTypes from 'prop-types'
import ModeEdit from 'material-ui/svg-icons/editor/mode-edit'
import css from '../../../patientCard.css'

const InfoAndEditButton = ({ contactInfoLabel, contactInfo, editContact }) => (
  <div>
    <span className={css.label}>{contactInfoLabel}</span>
    <div className={css.displayContactInfo}>
      <p>{contactInfo}</p>
      <button className={css.contactIconContainer} onClick={editContact}>
        <ModeEdit />
      </button>
    </div>
  </div>
)

InfoAndEditButton.PropTypes = {
  contactInfoLabel: PropTypes.string.isRequired,
  contactInfo: PropTypes.string.isRequired,
  editContact: PropTypes.func.isRequired,
}

export default InfoAndEditButton



// WEBPACK FOOTER //
// ./src/components/PatientPage/PatientCard/ContactField/EnabledField/ShowContact/InfoAndEditButton.js